var _Path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgBagContactGlove(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 21 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M16.5 11.5c0-4 1.5-3 1.5-6S16 1 10 1C7 1 1 2 1 8.5s3 5 3 11S4 25 5 26s10 1 11-1-.5-4.5 0-6.5 4-4.5 4-7.5c0-3.282-1.738-4.167-2.072-4.5M4 19c1.833.667 6.8 1.6 12 0"
  })));
}

export default SvgBagContactGlove;